export default {
  PHONE: /^01(0|1|2|5)[0-9]{8}$/,
};
